module.exports = __webpack_public_path__ + "static/img/51talk.7f3fea2.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/51talk.gif
// module id = Pnvc
// module chunks = 1